const Footer = () => {
  return (
    <div className='bg-sky-900 text-left'>
      <p className='ml-5 text-md font-medium w-full my-5 text-white'>© 2020 DM GROUP. All Rights Reserved.</p>
    </div>
  )
}

export default Footer
